<template>
  <section class="story05">
    <h2 class="story05--tit">INCELLDERM</h2>
    <p class="story05--descript">어린 세포 발견의 비밀</p>
    <div class="container">
        <ul class="row">
          <li
            class="col-6 col-sm-3 story05--prowrap"
            v-for="product in productList"
            :key="product.productsId"
          >
            <div class="img--wrap">
              <img
                :src="product.productsMainImageUrl"
                class="story05--img pointer"
                alt=""
                @click="
                  $router.push({
                    name: 'ProductDetail',
                    params: { productId: product.productsId },
                  })
                "
              />
            </div>
            <h3 class="story05--protit">{{ product.productsPageKoreanName }}</h3>
            <p class="story05--protxt">{{ product.productsPageEnglishName }}</p>
          </li>
        </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section5',
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped>
.pointer{
  cursor: pointer;
}
</style>
